import { useEffect } from 'react'
import nanoid from 'nanoid'

import {
  FORM_ID,
  USER_ID,
  getSavedOrderId,
  saveUserId,
  saveFormId,
  saveOrderId,
} from '../local-storage'
import { request } from '../utils/helpers'
import { IdKind } from '../types/common-types'
import {
  ORDER_TOKEN_ENDPOINT,
  TOKEN_ENDPOINT,
} from '../server-parameters'

// Request userId or formId from server.
// Sends the existing token back so the backend returns the same ID
// if the form hasn't been submitted yet — preserving uploaded files.
export async function getId(
  kind: IdKind,
  userId?: string,
  token?: string
): Promise<string> {
  const id = await request(
    TOKEN_ENDPOINT,
    {
      kind,
      userId,
      token,
    },
    'Error while token generation'
  )
  if (!id) {
    return nanoid(64)
  }
  return id
}

export async function getOrderId(): Promise<string> {
  const id = await fetch(ORDER_TOKEN_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
  })
    .then(response => {
      if (response.status === 200) return response
    })
    .catch(e => {
      console.log('errorid', id)
    })
  const token = await id?.json()
  if (!token?.access_token) {
    return nanoid(64)
  }
  return token?.access_token
}

interface UseTokenCallback {
  ({
    userId,
    formId,
  }: {
    userId: string
    formId: string
  }): void
}

// Fetch api to get userId and formId.
// Passes existing tokens so the backend preserves them when the form
// is still in progress — avoids desync between uploaded files and formId.
export async function getUserAndFormId(
  callback: UseTokenCallback,
  localStorage: Storage
) {
  const existingUserId = localStorage.getItem(USER_ID) ?? undefined
  const existingFormId = localStorage.getItem(FORM_ID) ?? undefined
  const userId = await getId('userId', undefined, existingUserId)
  const formId = await getId('formId', userId, existingFormId)
  const orderId = await getOrderId()
  saveUserId(userId, localStorage)
  saveFormId(formId, localStorage)
  saveOrderId(orderId, localStorage)
  callback({ userId, formId })
}

export function useToken(callback: UseTokenCallback, deps: unknown[] = []) {
  useEffect(() => {
    getUserAndFormId(callback, localStorage)
  }, deps)
}
